import styles from "./CheckoutStepper.module.scss";
import { Step } from "../../atoms/stepper/Step";
import PropTypes from "prop-types";
import StepMobile from "../../atoms/stepper/StepMobile";
import { CheckoutJourneyContext } from "../../../context/checkout-journey-context";

export const CheckoutStepper = ({ steps = [], activeStepNo, stepsWidth }) => {
  return (
    <CheckoutJourneyContext.Consumer>
      {(context) => (
        <div className={`${styles["stepper-container"]}`}>
          <div className={`${styles["stepper"]} ${styles[stepsWidth]}`}>
            {steps.map((step, index) => {
              const isComplete =
                activeStepNo > step.stepNo ||
                activeStepNo === steps[steps.length - 1]?.stepNo;
              const isActive = activeStepNo === step.stepNo;

              return (
                <Step
                  key={index}
                  value={step.stepNo}
                  isActive={isActive}
                  isComplete={isComplete}
                  step={step.title}
                  id={step.id}
                />
              );
            })}
          </div>
        </div>
      )}
    </CheckoutJourneyContext.Consumer>
  );
};

CheckoutStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
    })
  ),
  activeStepNo: PropTypes.number,
};

export const MobileCheckoutStepper = ({ steps = [], activeStepNo }) => {
  const index = steps.findIndex((step) => step.stepNo === activeStepNo);
  const currentStep = steps[index];
  const nextStep = steps[index + 1 < steps.length ? index + 1 : index];

  return (
    <StepMobile
      step={currentStep && currentStep.stepNo}
      totalSteps={steps && steps.length}
      title={currentStep && currentStep.heading}
      nextStepTitle={nextStep && nextStep.heading}
      id={currentStep && currentStep.id}
      nextStepId={nextStep && nextStep.id}
    />
  );
};

MobileCheckoutStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
    })
  ),
  activeStepNo: PropTypes.number,
};
